export const SKIP_RENDER = null;
export const EMPTY_STRING = '';
export const SPACE = ' ';
